
import { IGetUIElement } from 'wtw-ui-components';

export class NewClaimContentData {
    uiElements: IGetUIElement[];
}
